import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Typography, Layout, Spin, Space } from "antd";
import { UserOutlined, TeamOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import lingkarancekapLogoImg from "../assets/lingkarancekap_blue_logo.png";

const { Title, Text } = Typography;
const { Content } = Layout;

const apiParkingBase = process.env.BUN_PUBLIC_PARKING_API_BASE;

export function Home() { 
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const parkingLocationId = searchParams.get('id') || '';
  const [configLoading, setConfigLoading] = useState(true);
  const [enableRegistration, setEnableRegistration] = useState(false);
  const [locationName, setLocationName] = useState('');

  useEffect(() => {
    const fetchConfig = async () => {
      if (!parkingLocationId) {
        setConfigLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${apiParkingBase}/api/public/parking-locations/settings`, {
          params: { id: parkingLocationId }
        });
        setEnableRegistration(response.data.enable_registration || false);
        setLocationName(response.data.location || '');
      } catch (error) {
        console.error("Failed to fetch config:", error);
        setEnableRegistration(false);
      } finally {
        setConfigLoading(false);
      }
    };
    fetchConfig();
  }, [parkingLocationId]);

  if (configLoading) {
    return (
      <Layout className="page-layout" style={{ minHeight: '100%' }}>
        <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100%' }}>
          <Card style={{ textAlign: 'center', padding: '40px' }}>
            <Spin size="large" />
            <div style={{ marginTop: 16, fontSize: '16px' }}>{t("Loading...")}</div>
          </Card>
        </Content>
      </Layout>
    );
  }

  if (!enableRegistration) {
    return (
      <Layout className="page-layout" style={{ minHeight: '100%' }}>
        <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100%', padding: '24px' }}>
          <Card style={{ textAlign: 'center', padding: '40px', maxWidth: '600px' }}>
            <Title level={2} style={{ color: '#e8e8e8', marginBottom: 24 }}>
              {locationName || t("License Plate Recognition (LPR) Lanes Registration")}
            </Title>
            <div style={{ padding: '24px', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Text style={{ color: '#e8e8e8', fontSize: '1.7rem' }}>
                {t("Registration is currently disabled for this location.")}
              </Text>
            </div>
          </Card>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout className="page-layout" style={{ minHeight: '100%' }}> 
      <Content
        style={{
          padding: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100% - 70px)',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '900px',
            margin: '0 auto',
          }}
        >
          <Card
            style={{
              width: '100%',
              background: 'rgba(255, 255, 255, 0.85)',
              borderRadius: '16px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
              padding: '40px 32px',
            }}
          >
            {/* Logo Section */}
            {/* <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <img 
                src={lingkarancekapLogoImg}
                alt="Logo"
                style={{
                  height: '100px',
                  width: 'auto',
                  display: 'inline-block',
                }}
              />
            </div> */}

            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <Title 
                level={3}
                className="title-blue"
                style={{ 
                  marginBottom: 8,
                  fontSize: '1.7rem',
                  fontWeight: 700
                }}
              >
                {t("Welcome to the License Plate Recognition (LPR) Lanes Registration System")}
              </Title>
            </div>
            
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <Text className="title-blue" style={{ fontSize: '20px', fontWeight: 600 }}>
                {t("Please Select Your Registration Type")}
              </Text>
            </div>
            
            <Row gutter={[24, 24]} style={{ marginTop: 8 }}>
              <Col xs={24} md={12}>
                <Card
                  hoverable
                  style={{
                    borderRadius: '12px',
                    border: '2px solid #e8e8e8',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    height: '100%'
                  }}
                  styles={{
                    body: { padding: '24px' }
                  }}
                  onClick={() => navigate({ pathname: "/resident", search: searchParams.toString() })}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#667eea';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(24, 144, 255, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 16px'
                    }}>
                      <UserOutlined style={{ fontSize: '32px', color: 'white' }} />
                    </div>
                    <Title level={4} style={{ marginBottom: 8, marginTop: 0 }}>
                      {t("Resident")}
                    </Title>
                    <Text style={{ color: '#666', fontSize: '15px' }}>
                      {t("Register your personal vehicle plate number.")}
                    </Text>
                  </div>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card
                  hoverable
                  style={{
                    borderRadius: '12px',
                    border: '2px solid #e8e8e8',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    height: '100%'
                  }}
                  styles={{
                    body: { padding: '24px' }
                  }}
                  onClick={() => navigate({ pathname: "/company", search: searchParams.toString() })}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#52c41a';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(82, 196, 26, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 16px'
                    }}>
                      <TeamOutlined style={{ fontSize: '32px', color: 'white' }} />
                    </div>
                    <Title level={4} style={{ marginBottom: 8, marginTop: 0 }}>
                      {t("Company")}
                    </Title>
                    <Text style={{ color: '#666', fontSize: '15px' }}>
                      {t("Register company vehicles and vehicles of employees under your company.")}
                    </Text>
                  </div>
                </Card>
              </Col>
            </Row>
          </Card>
        </div>
      </Content>
    </Layout>
  );
}